module.exports = __webpack_public_path__ + "static/media/lora_indoor_modbus.5213fcaf.md";